import { Box, Container, Grid, Link, Typography, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FlowentiLogo from "image/Logo.svg"
import { getTranslation } from 'common';
import { useTranslations } from 'hooks';
import { Facebook, Instagram } from '@mui/icons-material';

const Footer = ({ lang }: { lang?: string }) => {
    const year = new Date().getFullYear();
    const translation = useTranslations()
    const language = navigator.language.split("-")[0] || "en";
    const privacyPolicyUrl = `/privacy-policy-${language}.html`;
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? theme.palette.background.paper : '#f8f9fa',
                pt: 8,
                pb: 4,
            }}
        >
            <Container maxWidth="lg">
                {/* Main Footer Content */}
                <Grid
                    container
                    spacing={4}
                    sx={{
                        mb: 6,
                        justifyContent: 'center',
                        alignItems: 'flex-start'
                    }}
                >
                    {/* Brand Section */}
                    <Grid item xs={12} md={2.4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Box
                                sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1.5,
                                }}
                            >
                                <img src={FlowentiLogo} alt="Flowenti Logo" style={{ height: 30 }} />
                            </Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    color: 'text.primary',
                                }}
                            >
                                Flowenti
                            </Typography>
                        </Box>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                lineHeight: 1.6,
                            }}
                        >
                            {getTranslation(translation, "footer.claim")}                        </Typography>
                    </Grid>

                    {/* Contacts Column */}
                    <Grid item xs={12} sm={4} md={2.4}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 700,
                                color: 'text.primary',
                                mb: 2,
                            }}
                        >
                            {getTranslation(translation, "generic.contacts")}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Link
                                href="mailto:support@flowenti.com"
                                underline="none"
                                sx={{
                                    color: 'text.secondary',
                                    '&:hover': { color: 'text.primary' },
                                }}
                            >
                                support@flowenti.com
                            </Link>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                }}
                            >
                                VIA DI VALLE MORTA 10 - 00132 ROMA (RM)
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                }}
                            >
                                P.IVA: 16189071000
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Bottom Bar */}
                <Box
                    sx={{
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        pt: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        © {year} Flowenti Technologies S.r.l. All rights reserved.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        <Link href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                        </Link>
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton
                            size="small"
                            href="https://www.linkedin.com/company/flowenti/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'text.secondary',
                            }}
                        >
                            <LinkedInIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            href="https://x.com/FlowentiBPM"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'text.secondary',
                                '&:hover': { color: '#1da1f2' },
                            }}
                        >
                            <TwitterIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            href="https://www.youtube.com/@flowenti"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'text.secondary',
                                '&:hover': { color: '#1da1f2' },
                            }}
                        >
                            <YouTubeIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            href="https://www.facebook.com/FlowentiBPM"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'text.secondary',
                                '&:hover': { color: '#1da1f2' },
                            }}
                        >
                            <Facebook fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            href="https://www.instagram.com/flowentibpm/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'text.secondary',
                                '&:hover': { color: '#1da1f2' },
                            }}
                        >
                            <Instagram fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
